export default "__VITE_ASSET__BEzlI661__"